import { takeLatest, call, put } from "redux-saga/effects"
import axios from "axios"
import { message } from "antd"

import { push } from "connected-react-router"
import {
  GET_LEADERS_SUMMARY_WATCHER,
  UPLOAD_TEMPLATE_LEADERS_WATCHER,
  SAVE_EXCEL_LEADERS_WATCHER,
} from "./constants"

import {
  getLeadersSummarySuccess,
  getLeadersSummaryFailed,
  uploadTemplateLeadersFailed,
  uploadTemplateLeadersSuccess,
  saveExcelLeadersProgress,
  saveExcelLeadersSuccess,
} from "./actions"
import { LOCAL_TOKEN } from "../../utils/storage"

function messageProgress(messagex) {
  message.loading(messagex, 0)
}

function messageSuccess(messagex) {
  message.success(messagex, 5)
}

function messageFailed(messagex) {
  message.error(messagex, 5)
}

function messageDestroy() {
  message.destroy()
}

// GET SUMMARY
function getLeadersSummaryApi() {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}employees/teamleader/import/xlsx/summary`,
  })
}

function* getLeadersSummary(action) {
  try {
    const { data, status } = yield call(getLeadersSummaryApi)
    if (status === 200) {
      yield put(getLeadersSummarySuccess(data.data.result[0].summary))
    }
  } catch (error) {
    returnMessage(error)
    yield put(getLeadersSummaryFailed())
  }
}

// UPLOAD EXCEL
function uploadTemplateLeaders(payload) {
  return axios.request({
    method: "post",
    url: `${process.env.API_URL}employees/teamleader/import/xlsx`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    data: payload,
  })
}

function uploadTemplateLeadersProgress(payload) {
  return axios.request({
    method: "get",
    url: `${process.env.API_URL}employees/teamleader/import/xlsx/progress`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    params: payload,
    validateStatus: (status) => true, // I'm always returning true,
  })
}

export function* uploadTemplateLeadersWatcher(action) {
  try {
    yield call(messageProgress, "Cargando archivo")
    yield call(uploadTemplateLeaders, action.payload)
    let data
    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 1000))
      data = yield call(uploadTemplateLeadersProgress)
      if (data.status === 200) {
        yield call(getLeadersSummary)
        yield call(messageDestroy)
        returnMessage(data)
        yield put(uploadTemplateLeadersSuccess())
        break
      }
      if (data.status === 500) {
        yield call(messageDestroy)
        message.error(data.data.data.error, 5)
        yield put(uploadTemplateLeadersFailed())
        break
      }
    }
  } catch (error) {
    yield put(uploadTemplateLeadersFailed())
    yield call(messageDestroy)
    yield call(messageFailed, "Error al importar archivo")
  }
}

// SAVE EXCEL
function saveExcelLeadersApi(params) {
  const invitate = params.invitate
    ? "?send_invitation=true"
    : "?send_invitation=false"
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}employees/teamleader/import/xlsx/confirm${invitate}`,
    validateStatus: (status) => true, // I'm always returning true,
  })
}

function saveExcelLeadersProgressApi() {
  return axios.request({
    method: "get",
    url: `${process.env.API_URL}employees/teamleader/import/xlsx/confirm/progress`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    validateStatus: (status) => true, // I'm always returning true,
  })
}

export function* saveExcelLeadersSaga(action) {
  try {
    yield call(saveExcelLeadersApi, action.payload)
    let data
    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 200))
      data = yield call(saveExcelLeadersProgressApi)
      if (data.status === 202) {
        yield put(saveExcelLeadersProgress(data.data.data.result[0].percentage))
      }
      if (data.status === 200) {
        yield put(saveExcelLeadersProgress(100))
        yield put(saveExcelLeadersSuccess(data))
        break
      }
    }
  } catch (error) {
    returnMessage(error)
  }
}

// Individual exports for testing
export default function* leadersSummarySaga() {
  yield takeLatest(SAVE_EXCEL_LEADERS_WATCHER, saveExcelLeadersSaga)
  yield takeLatest(GET_LEADERS_SUMMARY_WATCHER, getLeadersSummary)
  yield takeLatest(
    UPLOAD_TEMPLATE_LEADERS_WATCHER,
    uploadTemplateLeadersWatcher
  )
  // See example in containers/HomePage/saga.js
}
